import React from "react";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  RadioGroup,
  Radio,
  HStack,
  VStack,
} from "@chakra-ui/react";
import { Controller, useFormContext } from "react-hook-form";

const CommonRadioField: React.FC<CommonRadioFieldProps> = ({
  name,
  control,
  label,
  options = [],
  rules,
  orientation = "vertical",
  spacing = 4,
  colorScheme = "blue",
  size = "md",
  ...rest
}) => {
  const {
    formState: { errors },
  } = useFormContext();

  const error = errors[name];
  const errorMessage =
    typeof error === "object" && error !== null ? error.message : undefined;

  // Choose the appropriate Stack component based on orientation
  const StackComponent = orientation === "horizontal" ? HStack : VStack;

  return (
    <FormControl isInvalid={!!error}>
      <FormLabel fontWeight={600} fontSize="16px" color="#2F2F34" mb={3}>
        {label}
      </FormLabel>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field: { value, onChange } }) => (
          <RadioGroup
            value={value?.toString() || ""} // ← FIX: Convert to string
            onChange={onChange}
            colorScheme={colorScheme}
            size={size}
            {...rest}
          >
            <StackComponent
              spacing={spacing}
              align={orientation === "horizontal" ? "center" : "flex-start"}
            >
              {options?.map((option) => (
                <Radio
                  key={option.value}
                  value={option.value.toString()}
                  isDisabled={option.isDisabled}
                  colorScheme={colorScheme}
                  size={size}
                  _focus={{
                    boxShadow: "none",
                    borderColor: "#1819B4",
                  }}
                  sx={{
                    ".chakra-radio__control": {
                      borderColor: error ? "#E53E3E" : "#CDD6DC",
                      _hover: {
                        borderColor: error ? "#E53E3E" : "#1819B4",
                      },
                      _checked: {
                        bg: error ? "#E53E3E" : "#1819B4",
                        borderColor: error ? "#E53E3E" : "#1819B4",
                        _hover: {
                          bg: error ? "#E53E3E" : "#1819B4",
                          borderColor: error ? "#E53E3E" : "#1819B4",
                        },
                      },
                    },
                    ".chakra-radio__label": {
                      color: "#2F2F34",
                      fontSize: "14px",
                      fontWeight: 400,
                    },
                  }}
                >
                  {option.label}
                </Radio>
              ))}
            </StackComponent>
          </RadioGroup>
        )}
      />
      <FormErrorMessage mt={2}>
        {typeof errorMessage === "string" ? errorMessage : null}
      </FormErrorMessage>
    </FormControl>
  );
};

export default CommonRadioField;
